/**
 * Triggers a browser download from a PDF fetch Response.
 *
 * Filename order:
 * 1. `downloadFilename` prop (append .pdf if missing)
 * 2. Content-Disposition header
 * 3. "document.pdf"
 */
export async function downloadPdfFromResponse(
  response: Response,
  downloadFilename?: string
): Promise<void> {
  if (!response.ok) {
    throw new Error(`Download failed: ${response.statusText}`);
  }

  let filename: string;
  if (downloadFilename) {
    filename = downloadFilename.toLowerCase().endsWith(".pdf")
      ? downloadFilename
      : `${downloadFilename}.pdf`;
  } else {
    const contentDisposition = response.headers.get("Content-Disposition");
    const filenameMatch = contentDisposition?.match(/filename="?([^"]+)"?/);
    filename = filenameMatch?.[1] || "document.pdf";
  }

  const blob = await response.blob();
  const downloadUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(downloadUrl);
}
